export const FAILED = 'FAILED';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const UNINITIALIZED = 'UNINITIALIZED';